"use client";

import { useEffect, useState } from "react";

function useIsMobile() {
	const [isMobile, setIsMobile] = useState<boolean>(false);

	useEffect(() => {
		const checkIfMobile = () => {
			const width = window.innerWidth;
			setIsMobile(width < 768);
		};

		checkIfMobile();

		window.addEventListener("resize", checkIfMobile);
		return () => {
			window.removeEventListener("resize", checkIfMobile);
		};
	}, []);

	return isMobile;
}

export default useIsMobile;
